module.exports = __webpack_public_path__ + "static/img/2023_9_8_1.4dcda70d.4dcda70.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/2023_9_8_1.4dcda70d.jpg
// module id = LzqE
// module chunks = 0